import React, { useEffect } from 'react';
import { Dropdown } from 'Common/Components/Dropdown';
import withTranslation from '../../withTranslation';
import { currencies } from 'Common/constants/currencies';
import { useCurrency } from '../Currency/CurrencyContext';

const CurrencyDropdown = () => {
    const { currency } = useCurrency(); // currency ahora es un objeto, no solo un string

    const changeCurrency = (newCurrency: string) => {        
        // Actualizamos la moneda en el contexto
        currency.setCurrency(newCurrency ?? currencies.MXN);

        // Guardamos la nueva moneda en localStorage
        localStorage.setItem("CURRENCY", newCurrency);
    };

    useEffect(() => {
        const localCurrency = localStorage.getItem("CURRENCY");
        currency.setCurrency(localCurrency ?? currencies.MXN);
    }, [])

    return (
        <React.Fragment>
            <Dropdown className="relative flex items-center h-header">
                <Dropdown.Trigger type="button" className="inline-flex justify-center items-center p-0 text-topbar-item transition-all w-[37.5px] h-[37.5px] duration-200 ease-linear bg-topbar rounded-md dropdown-toggle btn-dropdown hover:bg-topbar-item-bg-hover hover:text-topbar-item-hover group-data-[topbar=dark]:bg-topbar-dark group-data-[topbar=dark]:hover:bg-topbar-item-bg-hover-dark group-data-[topbar=dark]:hover:text-topbar-item-hover-dark group-data-[topbar=brand]:bg-topbar-brand group-data-[topbar=brand]:hover:bg-topbar-item-bg-hover-brand group-data-[topbar=brand]:hover:text-topbar-item-hover-brand group-data-[topbar=dark]:dark:bg-zink-700 group-data-[topbar=dark]:dark:hover:bg-zink-600 group-data-[topbar=dark]:dark:text-zink-500 group-data-[topbar=dark]:dark:hover:text-zink-50" id="currenciesDropdown" data-bs-toggle="dropdown">                    
                    <span className='text-sm font-semibold text-black'>{currency.value}</span> {/* Ahora accedes a currency.value */}
                </Dropdown.Trigger>
                <Dropdown.Content placement="right-end" className="absolute z-50 p-0 ltr:text-left rtl:text-right bg-white rounded-md shadow-md !top-4 dropdown-menu min-w-[10rem] flex flex-col gap-2 dark:bg-zink-600" aria-labelledby="flagsDropdown">
                    {Object.keys(currencies).map((currencyKey, key) => (
                        <button 
                            type='button' 
                            className={`flex justify-center w-full text-black hover:text-white hover:bg-custom-500 p-2 items-center gap-3 text-center`} 
                            onClick={() => changeCurrency(currencyKey)}
                            key={key}
                        >
                            <span className='w-full text-sm font-semibold'>{currencyKey}</span>
                        </button>
                    ))}
                </Dropdown.Content>
            </Dropdown>
        </React.Fragment>
    );
};

export default withTranslation(CurrencyDropdown);